import { Accordion } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const MobileFilterBox = styled(Accordion, {})({
  width: '100%',

  borderTop: `1px solid ${theme.palette.lightgrey}44`,
  background: theme.palette.white,

  '& .MuiTypography-h5': {
    padding: '0 10px',

    fontSize: 18,
  },

  '& .clear': {
    opacity: 0,

    pointerEvents: 'none',
  },

  '&.Mui-expanded': {
    '& .clear': {
      opacity: 1,

      pointerEvents: 'all',
    },
  },
});
